import React from "react";
import { BtnEcovest } from "../../component/ecovestonboarding/BtnEcovest";
import { Carousel } from "../../component/ecovestonboarding/Carousel";
import { Logo } from "../../assets/icons/Logo";
import { SocialMediaFacebook1 } from "../../assets/icons/SocialMediaFacebook1";
import { SocialMediaGoogle } from "../../assets/icons/SocialMediaGoogle";
import { SocialMediaLinkedin } from "../../assets/icons/SocialMediaLinkedin";
import "./style.css";

const EcovestOnboarding = () => {
  return (
    <div className="ecovest-onboarding-container d-flex flex-column">
      <div className="ecovest-onboarding mx-auto d-flex w-100">
        <div className="hero-section mx-auto">
          <div className="overlap-3">
            <div className="rectangle-4"></div>
            <div className="d-flex flex-column ms-5 mt-5 logo-ecovest gap-5 w-75">
              <div className="d-flex">
                <img
                  className="d-flex"
                  alt="Logo mark"
                  src="/assets/images/ecovestonboarding/LogoEcovest.png"
                />
              </div>
              <div className="d-flex flex-column gap-5">
                <div className="d-flex flex-column gap-5">
                  <p className="text-wrapper-17">
                    Grow your investments, grow a greener world !
                  </p>

                 <p className="text-wrapper-18">
                  Welcome to Tannit Ecovest, the virtual forest where your green
                  investments cultivate real change. Join the movement and plant
                  virtual trees as you invest in sustainable real estate.
                  </p>
                </div>

                <div className="btn-ecovest-wrapper p-0">
                  <BtnEcovest
                    className="btn-ecovest-instance px-4"
                    stateProp="one-default"
                    text="Become an Eco-Investor. Plant Your Tree Today!"
                  />
                </div>
                <div className="d-flex justify-content-end">
                <div className="d-flex">
                  <div className="d-flex flex-column gap-2 ellipse-13">
                    <div className="d-flex gap-4 trees-planted">
                      <img className="pikpng" alt="Pikpng" src="/assets/images/ecovestonboarding/pikpng-4-1.png" />
                      <img className="pikpng-2" alt="Pikpng" src="/assets/images/ecovestonboarding/pikpng-3-1.png"/>
                    </div>
                    <div className="frame-19 mt-5 mx-auto d-flex align-self-center">
                      <div className="text-wrapper-19">3719</div>

                     <div className="planted-trees-until">
                       planted trees
                        <br />
                       until now !
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="element-tiny">
              <video width="1438" height="811" autoPlay loop muted>
                <source src="https://cdn.pixabay.com/video/2018/10/02/18534-293472901_large.mp4" type="video/mp4"/>
              </video>
          </div>
          <div className="ellipse-12" />
        </div>
      </div>
    </div>
    <div className="ecovest-onboarding mx-auto d-flex w-100 second-position">
        <div className="overlap-wrapper w-100 mb-3">
                <div className="d-flex flex-column">
                  <div className="d-flex flex-column">
                    <div className="d-flex flex-column ms-5 mt-5">
                        <div className="playful-engaging">Playful &amp; Engaging</div>

                        <p className="text-wrapper">
                          At Tannit, we believe in investing that makes a difference
                        </p>
                    </div>
                    <BtnEcovest
                      className="design-component-instance-node d-flex col-lg-2 col-md-4 col-sm-4 col-9 ms-5"
                      stateProp="two-default"
                      text="Plant tree for impact"
                    />
                    <div className="image d-flex flex-column gap-5 justify-content-end align-items-end align-self-end mt-5">
                      <img className="w-100" alt="Image" src="/assets/images/ecovestonboarding/image-212.png" />
                    </div>
                  </div>
                  <div className="d-flex flex-column">
                    <img className="img-faces w-100 h-auto" alt="Vector" src="/assets/images/ecovestonboarding/vector-7.svg" />
                    <img className="img-faces-2 w-100 h-auto" alt="Mask group" src="/assets/images/ecovestonboarding/mask-group.png" />
                  </div>
                  <div className="rectangle w-100">
                  <div className="d-flex flex-column justify-content-center align-items-center gap-4 mb-5">
                    <img className="image-2 w-50 h-auto" alt="Image" src="/assets/images/ecovestonboarding/image-213.png" />
                    <div className="d-flex flex-column gap-5 justify-content-center align-items-center align-self-center mt-5">
                      <img
                        className="w-25"
                        alt="Logo mark"
                        src="/assets/images/ecovestonboarding/logo-mark-1.png"
                      />

                      <div className="text-wrapper-9">what’s Tannit Ecovest?</div>
                    </div>

                    <p className="text-wrapper-10">
                      Invest sustainably, level up your impact.
                    </p>

                    <p className="text-wrapper-11">
                      At Tannit, we believe in creating a positive impact that starts
                      with your choices. Introducing Ecovest, a unique program where
                      your real estate investments and platform interactions cultivate
                      a virtual forest and contribute to tangible environmental
                      change.
                    </p>
                    <img className="image-4 w-25 h-auto" alt="Image" src="/assets/images/ecovestonboarding/image-214.png" />
                    <BtnEcovest
                      className="btn-ecovest-instance"
                      stateProp="two-default"
                      text="Plant tree for impact"
                    />
                  </div>
                  </div>
                  <div className="bg-white d-flex flex-column">
                  <div className="d-flex flex-column gap-3 col-lg-6 col-md-8 col-sm-12 col-12 mx-2">
                    <div className="d-flex flex-column gap-5">
                      <div className="container-wrapper-xp col-lg-5 col-md-8 col-sm-9 col-9">
                        <div className="d-flex justify-content-center align-items-center gap-3 p-3">
                          <img
                            className="green-coin"
                            alt="Green coin"
                            src="/assets/images/ecovestonboarding/green-coin.svg"
                          />

                          <div className="balance">
                            <div className="text-wrapper-2">8K XP</div>

                            <div className="frame-5">
                              <img
                                className="image-3"
                                alt="Image"
                                src="/assets/images/ecovestonboarding/image-86.png"
                              />

                              <div className="text-wrapper-3">3</div>
                            </div>

                            <div className="frame-wrapper">
                              <div className="frame-6" />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="frame-7 px-2">
                        <p className="p">Grow Your Forest, One Action at a Time!</p>

                        <p className="earning-the-right-to">
                          <span className="span">
                            Earning the right to plant trees in the Ecovest forest is
                            easy and rewarding.{" "}
                          </span>

                          <span className="text-wrapper-4">
                            Here&#39;s how it works:
                          </span>
                        </p>
                      </div>
                    </div>

                    <div className="d-flex flex-column">
                      <div className="frame-9 px-2">
                        <p className="text-wrapper-5">
                          ⭐&nbsp;&nbsp;Engage &amp; Earn Green Coins:
                        </p>

                        <p className="earning-the-right-to">
                          Earn Green Coins for daily logins, social media shares,
                          sponsoring others, and most importantly, investing in
                          sustainable real estate projects on Tannit.
                        </p>
                      </div>

                      <div className="frame-9 px-2">
                        <div className="text-wrapper-5">
                          🚀&nbsp;&nbsp;Level Up with ExperiencE:
                        </div>

                        <p className="earning-the-right-to">
                          As you interact with the platform, you&#39;ll gain
                          experience points (XP). Each level unlocks the ability to
                          plant a specific tree type in the virtual forest.
                        </p>
                      </div>

                      <div className="frame-9 px-2">
                        <div className="text-wrapper-5">
                          🧭&nbsp;&nbsp;Track Your Progress:
                        </div>

                        <p className="earning-the-right-to">
                          A handy progress bar shows you how close you are to reaching
                          the next level.
                        </p>
                      </div>

                      <div className="frame-9 px-2">
                        <div className="text-wrapper-5">
                          🌲&nbsp;&nbsp;Plant Your Trees:
                        </div>

                        <p className="earning-the-right-to">
                          Once you reach a new level, the number of trees you can
                          plant will be displayed next to the tree icon. Simply access
                          the Ecovest virtual forest to plant your well-deserved
                          trees!
                        </p>
                      </div>
                    </div>
                  </div>
                  <img
                        className="green-beautiful-tree d-lg-flex d-md-none d-sm-none d-none"
                        alt="Green beautiful tree"
                        src="/assets/images/ecovestonboarding/green-beautiful-tree-isolated-white-background-generative-ai-2.png"
                    />
                  </div>
                </div>
              </div>
              </div>
              <div className="ecovest-onboarding mx-auto d-flex w-100 third-position">
              <div className="div-wrapper w-100">
                <div className="d-flex flex-column gap-1 justify-content-center align-items-center align-self-center my-3">
                  <div className="d-flex flex-column gap-2 justify-content-center align-items-center align-self-center">
                    <div className="d-flex flex-column justify-content-center align-items-center align-self-center">

                      <div>
                      <img
                        className="d-flex"
                        alt="Logo mark"
                        src="/assets/images/ecovestonboarding/LogoEcovest2.png"
                      />
                      </div>
                    </div>

                    <div className="d-flex flex-column justify-content-center align-items-center align-self-center">
                      <div className="text-wrapper-16">Unlock Your Eco-Power</div>

                      <div className="in-steps"> in 4 Steps</div>
                    </div>
                  </div>

                  <Carousel property1="default" className="ms-3" />
                  <BtnEcovest
                    className="btn-ecovest-instance mt-3"
                    stateProp="one-default"
                    text="Sign Up &amp; Join the Movement!"
                  />
                </div>
              </div>
              </div>
              <div className="ecovest-onboarding mx-auto d-flex w-100 fourth-position">
          <footer className="footer p-3 pb-5 w-100 d-flex flex-column">
            <div className="d-flex flex-lg-row flex-md-row flex-column">
            <div className="col-lg-6 col-md-6 col-sm-12 col-12">
            <Logo className="mb-3" />
            <p className="text-wrapper-12 col-lg-4 col-md-8 com-sm-12 col-12">
              Lorem ipsum dolor sit amet consectetur. Viverra suscipit senectus
              lorem facilis facilisi iaculis potenti massa euismod accumsan. Dictum
              pharetra
            </p>

            </div>
            <div className="frame-13 col-lg-6 col-md-6 col-sm-12 col-12">
              <div className="text-wrapper-12">Contact Us</div>

              <div className="text-wrapper-12">2035, Sousse , Sousse</div>

              <div className="text-wrapper-12">info@gmail.com</div>

              <div className="text-wrapper-12">+212 55 564 654</div>

              <div className="social-media">
                <SocialMediaFacebook1 className="icon-instance-node" />
                <SocialMediaLinkedin className="icon-instance-node" />
                <SocialMediaGoogle className="icon-instance-node" />
              </div>
            </div>
            </div>
            <img className="line" alt="Line" src="/assets/images/ecovestonboarding/line-2.svg" />
            <div className="d-flex mt-2 flex-lg-row flex-md-row flex-column">
            <p className="text-wrapper-12 col-lg-6 col-md-6 col-sm-12 col-12">@ 2024 All rights reserved</p>
            <p className="text-wrapper-12 col-lg-6 col-md-6 col-sm-12 col-12">
              Condition of use &amp; Privacy Policy
            </p>
            </div>
          </footer>
    </div>
    </div>
  );
};
export default EcovestOnboarding;